module.exports = __webpack_public_path__ + "fa7899c944ed53d4c1ded55c890a9f10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/lgb.png
// module id = 257
// module chunks = 1